import React from 'react';
import PolicyReport from '../LifePolicyRegister/PolicyReport';

// CurrentStatusReportPreview simply re-uses the existing PolicyReport component.
// The CurrentStatusReport form navigates to this route and passes payload in location.state.payload
// PolicyReport reads location.state.payload and will generate the report accordingly.
export default function CurrentStatusReportPreview() {
  // Pass includePolicyStatus and a clearer header title
  return <PolicyReport includePolicyStatus={true} headerTitle={"Current Policy Status Report"} />;
}
